import Search from "components/global/Search";
import Sidebar from "components/global/sidebar";
import Navbar from "components/user/navbar";
import Bilboard from 'assets/images/bilboard.png';
import { useLocation, useNavigate } from "react-router-dom";
import Heading from "components/global/Heading";
import Pagination from "components/global/pagination";
import { useEffect } from "react";
import BackBtn from "components/global/BackBtn";


const SellerScreens = () => {
    const navigate = useNavigate();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const viewScreenHandler = () => {
        navigate('/user/screen-details/23448')
    }

    return (
        <div className="w-full pb-20 md:px-0 px-4 pt-24  ">
            <Navbar />
            <div>
                <Sidebar />
            </div>
            <div className="w-full pl md:pr-20 ">
                <div className="md:px-2">
                    <div className="light-shadow flex sm:items-center gap-4 justify-between sm:flex-row flex-col-reverse w-full py-4 px-4 rounded-lg">
                        <Search />
                        <BackBtn />
                    </div>
                </div>
                <div>
                    <div className="py-12 pb-16">
                        <Heading title='Jack2245' />
                    </div>
                    <div>
                        <div className="grid lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-2 grid-cols-1 gap-6">
                            {
                                [...Array(8).keys()].map((item,i) => (
                                    <div 
                                    className='w-full bg-pure rounded-lg p-2 light-shadow' 
                                    key={i}
                                    >
                                        <div>
                                            <img src={Bilboard} alt="Case Study" className='w-full h-full' />
                                        </div>
                                        <div className='text-dark flex flex-col gap-1 mt-4'>
                                            <p>Starting Price: 3000INR</p>
                                            <p>Total Impression: 600k/m</p> 
                                            <p>Media Type: Static Image/Video</p>
                                            <p>Ad Medium: Billboards & Digital Screen</p>
                                            <p>Minimum Play: 1500</p>
                                            <p>Location: Banglore ,India</p>
                                        </div>
                                        <div className='pt-6 pb-4'>
                                            <button 
                                            className="btn-primary py-2"
                                            onClick={() => {
                                                viewScreenHandler()
                                            }}
                                            >
                                                View Screen
                                            </button>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                        <div className="flex item-center justify-center pt-8">
                            <Pagination />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SellerScreens;